import { render, staticRenderFns } from "./StockCategory.vue?vue&type=template&id=1ce6a09a&scoped=true&"
import script from "./StockCategory.vue?vue&type=script&lang=js&"
export * from "./StockCategory.vue?vue&type=script&lang=js&"
import style0 from "./StockCategory.vue?vue&type=style&index=0&id=1ce6a09a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce6a09a",
  null
  
)

export default component.exports